import { Component, OnInit } from '@angular/core';
import { WgisService } from '../wgis/wgis.service';
import { Router} from '@angular/router';
import { Angulartics2 } from 'angulartics2';
declare let $ : any;

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html'
})
export class HelpComponent implements OnInit {

  constructor(
    private wgisservice: WgisService,
    private router: Router,
    private angulartics2: Angulartics2
  ) {
    this.wgisservice.setMapInvisible();
  }

  ngOnInit() {
    $('.content.example .ui.embed').embed();
  }

}
